import { render, staticRenderFns } from "./NewsConfigChoose.vue?vue&type=template&id=c19dbea0&scoped=true"
import script from "./NewsConfigChoose.vue?vue&type=script&lang=js"
export * from "./NewsConfigChoose.vue?vue&type=script&lang=js"
import style0 from "./NewsConfigChoose.vue?vue&type=style&index=0&id=c19dbea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19dbea0",
  null
  
)

export default component.exports